import { gql } from "@apollo/client";

const getAllPlayers = gql`
    query {
        getPlayers {
            id,
            name,
            points,
            ppg,
            assists,
            apg,
            rebounds
            rpg,
            fouls,
            fpg
        }
    }`;

const START_GAME_MUTATION = gql`
mutation startGame($tenant: Int!, $game: GameTypeInput){
    startGame (tenant: $tenant, game: $game) {
                id
                status
                home {
                    type
                    points
                    assists
                    rebounds
                    fouls
                    players {
                        id
                        assists
                        fouls
                        name
                        points
                        rebounds
                    }
                }
                away {
                    type
                    points
                    assists
                    rebounds
                    fouls
                    players {
                        id
                        assists
                        fouls
                        name
                        points
                        rebounds
                    }
                }
            }
}
`

const END_GAME_MUTATION = gql`
mutation completeGame($tenant: Int!) {
    completeGame(tenant: $tenant) 
}`;

const GET_INPROGRESS_GAME = gql`
query inProgressGame($tenant: Int!){
    inProgressGame (tenant: $tenant) {
                id
                status
                home {
                    type
                    points
                    assists
                    rebounds
                    fouls
                    players {
                        id
                        assists
                        fouls
                        name
                        points
                        rebounds
                    }
                }
                away {
                    type
                    points
                    assists
                    rebounds
                    fouls
                    players {
                        id
                        assists
                        fouls
                        name
                        points
                        rebounds
                    }
                }
            }
}
`

const ADD_PLAYER_MUTATION = gql`
    mutation AddPlayer($player: AddPlayerType!) {
        addPlayer(player: $player) {
            id
            name
        }
    }`;

const ADD_STAT_MUTATION = gql`
    mutation RecordStat($tenant: Int!, $action: ScoreActions!, $team: TeamCategory!, $playerId: String!) {
        recordStat(tenant: $tenant, action: $action, team: $team, playerId: $playerId) {
            id
            status
            home {
                type
                points
                assists
                rebounds
                fouls
                players {
                    id
                    assists
                    fouls
                    name
                    points
                    rebounds
                }
            }
            away {
                type
                points
                assists
                rebounds
                fouls
                players {
                    id
                    assists 
                    fouls
                    name
                    points
                    rebounds
                }
            }
        }
    }
`

export {
    getAllPlayers,
    START_GAME_MUTATION,
    GET_INPROGRESS_GAME,
    ADD_PLAYER_MUTATION,
    ADD_STAT_MUTATION,
    END_GAME_MUTATION
}